export function filterClasses(
  ...classNames: Array<string | false | null | undefined>
) {
  return classNames.filter(Boolean).join(" ") || undefined;
}
